import { getPropByPath } from '../property-path';

export const SORT_DIRECTION = {
  ASC: 1,
  DESC: -1,
};

export class SortProperty {
  constructor(propertyName, sortAscending = true) {
    this.name = propertyName;
    this.ascending = sortAscending;
  }
}

// accepts a SortProperty object or array of SortProperty objects in order of precedence
// expect dot notation to be part of propName, so use getPropByPath
export const genericObjectSort = sortProps => (a, b) => {
  let prop = null;
  let remainingProps = null;

  if (
    Array.isArray(sortProps) &&
    sortProps.length &&
    sortProps.every(element => element.constructor === SortProperty)
  ) {
    const [firstProp, ...rest] = sortProps;
    prop = firstProp;
    remainingProps = rest;
  } else if (sortProps.constructor === SortProperty) {
    prop = sortProps;
  } else {
    return 0;
  }

  if (getPropByPath(a, prop.name) < getPropByPath(b, prop.name)) {
    return prop.ascending ? -1 : 1;
  }
  if (getPropByPath(a, prop.name) > getPropByPath(b, prop.name)) {
    return prop.ascending ? 1 : -1;
  }
  if (
    getPropByPath(a, prop.name) === getPropByPath(b, prop.name) &&
    remainingProps &&
    remainingProps.length
  ) {
    return genericObjectSort(remainingProps)(a, b);
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/common/utils/object-sort/index.js